import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'

class ThankYou extends React.Component {
  constructor () {
    super()
    this.state = {}
  }

  render () {
    let enableLatestNewsButton = JSON.parse(_.get(this.props.config.stringValues, 'site.thanksModal.enableLatestNewsButton', 'true'))
    return (
      <div className='thank-you'>
        <div className='container'>
          <div className='title1'>{ _.get(this.props.config.stringValues, 'site.thanksModal.title1', 'Thank You') }</div>
          <div className='title2'>{ _.get(this.props.config.stringValues, 'site.thanksModal.title2', 'For your Gift!') }</div>
          {enableLatestNewsButton && this.props.hasApps === false && !this.props.config.latestNewsRedirectUrl &&
            <div style={{margin: '0', padding: '0'}}>
              <div className='separator' />
              <div className={'latestNewsButton'} onClick={() => this.props.history.push('news-feed')} />
            </div>
          }
          {enableLatestNewsButton && this.props.hasApps === false && this.props.config.latestNewsRedirectUrl &&
            <div style={{margin: '0', padding: '0'}}>
              <div className='separator' />
              <a href={this.props.config.latestNewsRedirectUrl}>
                <div className={'latestNewsButton'} />
              </a>
            </div>
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  config: state.config
})

export default connect(
  mapStateToProps
)(withRouter(ThankYou))
